import {XMarkIcon} from '@heroicons/react/24/outline'
import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import Dialog from './Dialog'
import FlatButton from './FlatButton'
import {InternalLinkStyledAsFlatButton} from './links/InternalLink'

type Props = Readonly<{
  open: boolean
  onClose: () => void
}>

function ExistingAccountPopup({open, onClose}: Props): JSX.Element {
  const intl = useIntl()
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="flex flex-col items-center gap-10">
        <div className="flex w-full items-center justify-between">
          <Dialog.Title className="typography-headline-4 font-[700]">
            <FormattedMessage id="registration.existingAccount_title" />
          </Dialog.Title>
          <div>
            <FlatButton
              aria-label={intl.formatMessage({id: 'general.Close'})}
              icon={<XMarkIcon className="h-6 w-6" aria-hidden />}
              onClick={onClose}
              type="button"
              variant="transparent"
            />
          </div>
        </div>
        <div className="typography-headline-6 max-w-prose whitespace-pre-wrap text-center">
          <FormattedMessage
            id="registration.existingAccount_content"
            values={{strong: text => <strong>{text}</strong>}}
          />
        </div>
        <InternalLinkStyledAsFlatButton to="/login" variant="success">
          <FormattedMessage id="registration.existingAccount_action" />
        </InternalLinkStyledAsFlatButton>
      </div>
    </Dialog>
  )
}

export default ExistingAccountPopup
